import { BackLink } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ContentArticle } from './article/content-article';
import { ContentType } from './generated/content';

type ContentPageProps = {
  readonly type: ContentType;
  readonly id: string;
};

const handleUnknown = (type: never): never => {
  throw new Error('Unknown type: ' + type);
};

const ContentRender = ({ type, id }: ContentPageProps) => {
  switch (type) {
    case ContentType.Article:
      return <ContentArticle id={id} />;
    default:
      return handleUnknown(type);
  }
};

const ContentPage = (props: ContentPageProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="form-container">
      <BackLink onBack={() => navigate('/content')} text={t('common.buttons.back')} />
      <ContentRender {...props} />
    </div>
  );
};

export { ContentPage };
